import React from 'react';

const VendorLeadsTab = ({ leads }) => (
  <>
    <h2 className="text-lg font-bold mb-3">Buyer Leads</h2>
    <div className="bg-white border border-gray-200 rounded-md overflow-hidden">
      {leads.length === 0 ? (
        <div className="p-10 text-center text-gray-500">No leads yet. They&apos;ll appear here when buyers enquire about your products.</div>
      ) : (
        <table className="w-full text-sm">
          <thead className="bg-gray-50"><tr>
            <th className="px-4 py-2 text-left">Buyer</th><th className="px-4 py-2 text-left">Mobile</th>
            <th className="px-4 py-2 text-left">Product</th><th className="px-4 py-2 text-left">Message</th>
            <th className="px-4 py-2 text-left">When</th>
          </tr></thead>
          <tbody>
            {leads.map((l) => (
              <tr key={l.id} className="border-t border-gray-100">
                <td className="px-4 py-2 font-medium">{l.name}</td>
                <td className="px-4 py-2">
                  <a href={`tel:+91${l.mobile}`} className="text-[#2c54b2] hover:underline">+91 {l.mobile}</a>
                </td>
                <td className="px-4 py-2">{l.product_name || '—'}</td>
                <td className="px-4 py-2 text-gray-600 max-w-xs truncate">{l.message || '—'}</td>
                <td className="px-4 py-2 text-xs text-gray-500">{new Date(l.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  </>
);

export default VendorLeadsTab;
